const LangKeys = {
  reminders_wa_sent_toast: "reminders_wa_sent_toast",
  reminders_date_lbl: "reminders_date_lbl",
  reminders_set_due_date_selected: "reminders_set_due_date_selected",
  reminders_total: "reminders_total",
  reminders_customers_selected: "reminders_customers_selected",
  reminders_to: "reminders_to",
  reminders_max: "reminders_max",
  reminders_min: "reminders_min",
  reminders_by_due_date: "reminders_by_due_date",
  reminders_oldest_dues: "reminders_oldest_dues",
  reminders_highest_amount: "reminders_highest_amount",
  reminders_pending_amount_filter: "reminders_pending_amount_filter",
  reminders_collect_faster_sub: "reminders_collect_faster_sub",
  reminders_set_collection_date: "reminders_set_collection_date",
  reminders_day: "reminders_day",
  reminders_days: "reminders_days",
  reminders_due_in: "reminders_due_in",
  reminders_overdue_by: "reminders_overdue_by",
  reminders_auto_reminder_active: "reminders_auto_reminder_active",
  reminders_no_customers_matched: "reminders_no_customers_matched",
  reminders_no_customers_found: "reminders_no_customers_found",
  reminders_no_upcoming_sub: "reminders_no_upcoming_sub",
  reminders_no_upcoming_heading: "reminders_no_upcoming_heading",
  reminders_no_due_today_sub: "reminders_no_due_today_sub",
  reminders_no_due_today_heading: "reminders_no_due_today_heading",
  reminders_view_all_customers: "reminders_view_all_customers",
  reminders_no_overdue_sub: "reminders_no_overdue_sub",
  reminders_no_overdue_heading: "reminders_no_overdue_heading",
  reminders_all_up_to_date: "reminders_all_up_to_date",
  reminders_date: "reminders_date",
  reminders_call: "reminders_call",
  reminders_sms: "reminders_sms",
  reminders_whatsapp: "reminders_whatsapp",
  reminders_sent: "reminders_sent",
  reminders_pending_balance: "reminders_pending_balance",
  reminders_search_placeholder: "reminders_search_placeholder",
  reminders_suppliers: "reminders_suppliers",
  reminders_customers: "reminders_customers",
  reminders_all: "reminders_all",
  reminders_all_customers: "reminders_all_customers",
  reminders_total_dues: "reminders_total_dues",
  reminders_collect_faster: "reminders_collect_faster",
  reminders_title: "reminders_title",
  reminders_subtitle: "reminders_subtitle",
  reminders_total_outstanding: "reminders_total_outstanding",
  reminders_overdue: "reminders_overdue",
  reminders_due_today: "reminders_due_today",
  reminders_upcoming: "reminders_upcoming",
  reminders_no_date: "reminders_no_date",
  reminders_all_tab: "reminders_all_tab",
  reminders_today_tab: "reminders_today_tab",
  reminders_overdue_tab: "reminders_overdue_tab",
  reminders_upcoming_tab: "reminders_upcoming_tab",
  reminders_no_date_tab: "reminders_no_date_tab",
  reminders_search_hint: "reminders_search_hint",
  reminders_select_all: "reminders_select_all",
  reminders_selected: "reminders_selected",
  reminders_set_due_date: "reminders_set_due_date",
  reminders_change_due_date: "reminders_change_due_date",
  reminders_send_whatsapp: "reminders_send_whatsapp",
  reminders_send_all_whatsapp: "reminders_send_all_whatsapp",
  reminders_auto_reminder: "reminders_auto_reminder",
  reminders_auto_reminder_desc: "reminders_auto_reminder_desc",
  reminders_last_sent: "reminders_last_sent",
  reminders_not_sent: "reminders_not_sent",
  reminders_days_overdue: "reminders_days_overdue",
  reminders_days_left: "reminders_days_left",
  reminders_chip_today: "reminders_chip_today",
  reminders_chip_tomorrow: "reminders_chip_tomorrow",
  reminders_chip_3days: "reminders_chip_3days",
  reminders_chip_1week: "reminders_chip_1week",
  reminders_chip_15days: "reminders_chip_15days",
  reminders_chip_1month: "reminders_chip_1month",
  reminders_chip_custom: "reminders_chip_custom",
  reminders_time_lbl: "reminders_time_lbl",
  reminders_save_date: "reminders_save_date",
  reminders_clear_date: "reminders_clear_date",
  reminders_no_pending: "reminders_no_pending",
  reminders_no_pending_desc: "reminders_no_pending_desc",
  reminders_direct_wa: "reminders_direct_wa",
  reminders_cloud_wa: "reminders_cloud_wa",
  reminders_sending: "reminders_sending",
  reminders_bulk_success: "reminders_bulk_success",
  reminders_date_updated: "reminders_date_updated",

  fields: "fields",
  save_expense: "save_expense",
  photos: "photos",
  loading: "loading",
  no_items_found: "no_items_found",
  parties: "parties",
  unpaid: "unpaid",
  stock: "stock",

  add_bill_payment_details: "add_bill_payment_details",
  notes: "notes",
  edit_price_dialog_title: "edit_price_dialog_title",
  search_items_hint: "search_items_hint",
  address_flat_no: "address_flat_no",
  address_area: "address_area",
  add_bill_item_name: "add_bill_item_name",
  add_bill_item_price: "add_bill_item_price",
  add_bill_terms_conditions_hint: "add_bill_terms_conditions_hint",
  today: "today",
  delete_confirm: "delete_confirm",
  failed_load_dashboard: "failed_load_dashboard",
  moxpal_khata: "moxpal_khata",
  business_owner: "business_owner",
  processing: "processing",

  online_active: "online_active",
  online_private: "online_private",
  delete_confirmation: "delete_confirmation",
  item_name_required: "item_name_required",

  app_name: "app_name",
  header_subtitle: "header_subtitle xxxx",

  // SHARED KHATA
  shared_khata__summary: "shared_khata__summary",
  customer_name: "customer_name",
  mobile_no: "mobile_no",
  transaction_history: "transaction_history",
  total_debit: "total_debit",
  total_credit: "total_credit",
  net_balance: "net_balance",
  date: "date",
  credit: "credit",
  debit: "debit",
  balance: "balance",
  note: "note",
  call_support: "call_support",
  invalid_link: "invalid_link",
  footer: "footer",

  // COMMON
  settings: "settings",
  settings_subtitle: "settings_subtitle",
  language: "language",
  select_language: "select_language",
  close: "close",
  save: "save",
  retry: "retry",
  profile: "profile",
  logout: "logout",
  version: "version",
  copyright: "copyright",
  not_available: "not_available",
  total: "total",
  required_field: "required_field",
  product: "product",
  message_language: "message_language",
  follow_app: "follow_app",
  hindi: "hindi",
  english: "english",
  hinglish: "hinglish",
  gujarati: "gujarati",
  marathi: "marathi",
  punjabi: "punjabi",
  tamil: "tamil",
  telugu: "telugu",

  // SETTINGS PAGE
  business_settings: "business_settings",
  business_settings_desc: "business_settings_desc",
  staff_permissions: "staff_permissions",
  staff_permissions_desc: "staff_permissions_desc",
  backup_information: "backup_information",
  backup_information_desc: "backup_information_desc",
  delete_khata: "delete_khata",
  delete_khata_desc: "delete_khata_desc",
  app_update: "app_update",
  app_update_desc: "app_update_desc",
  app_up_to_date: "app_up_to_date",
  failed_to_check_for_update: "failed_to_check_for_update",
  whatsapp_service: "whatsapp_service",
  whatsapp_service_desc: "whatsapp_service_desc",

  // Whatsapp SMS Credtits PAGE
  whatsapp_credits: "whatsapp_credits",
  available_credits: "available_credits",
  whatsapp_balance: "whatsapp_balance",
  used: "used",
  credits: "credits",
  proceed_to_pay: "proceed_to_pay",
  recharge_plans: "recharge_plans",
  off: "off",
  load_failed: "load_failed",
  toggle_failed: "toggle_failed",
  order_failed: "order_failed",
  payment_error: "payment_error",
  payment_failed: "payment_failed",
  verification_failed: "verification_failed",
  recharge_successful: "recharge_successful",
  total_purchased: "total_purchased",
  premium_unlimited_active: "premium_unlimited_active",
  premium_unlimited_desc: "premium_unlimited_desc",

  // DASHBOARD / KHATA
  khata: "khata",
  you_will_get: "you_will_get",
  you_will_give: "you_will_give",
  search_khata_entry: "search_khata_entry",
  recent_entries: "recent_entries",
  unknown_party: "unknown_party",
  unknown_customer: "unknown_customer",
  unknown: "unknown",

  // BACKUP
  backup_info_text: "backup_info_text",
  last_backup_at: "last_backup_at",

  // DELETE KHATA
  delete_warning_text: "delete_warning_text",
  delete_placeholder: "delete_placeholder",
  delete_button: "delete_button",
  delete_name_mismatch: "delete_name_mismatch",

  // KHATA
  my_khata: "my_khata",
  search_customer: "search_customer",
  all_customers: "all_customers",
  no_customers_found: "no_customers_found",
  no_suppliers_found: "no_suppliers_found",
  no_parties_found: "no_parties_found",
  just_now: "just_now",
  min_ago: "min_ago",
  hr_ago: "hr_ago",
  day_ago: "day_ago",
  month_ago: "month_ago",
  year_ago: "year_ago",
  settled: "settled",
  advance: "advance",
  due: "due",
  no_entries_yet: "no_entries_yet",
  new_label: "new_label",
  no_transactions: "no_transactions",

  // CUSTOMER LEDGER
  ledger: "ledger",
  report: "report",
  reminder: "reminder",
  sms: "sms",
  whatsapp: "whatsapp",
  outstanding_balance: "outstanding_balance",
  total_balance: "total_balance",
  you_got: "you_got",
  you_gave: "you_gave",
  entries: "entries",
  no_entries_found: "no_entries_found",
  i_got: "i_got",
  i_gave: "i_gave",
  you_got_caps: "you_got_caps",
  you_gave_caps: "you_gave_caps",
  wa_dear: "wa_dear",
  wa_account_update: "wa_account_update",
  total_due: "total_due",
  view_full_account: "view_full_account",
  failed_to_load_data: "failed_to_load_data",
  could_not_open_whatsapp: "could_not_open_whatsapp",
  could_not_open_sms: "could_not_open_sms",
  total_purchase: "total_purchase",
  total_paid: "total_paid",
  total_received: "total_received",
  received: "received",
  paid: "paid",
  add_to_cashbook: "add_to_cashbook",
  entry_success: "entry_success",
  transaction_success: "transaction_success",
  done: "done",

  // ENTRY
  entry_details: "entry_details",
  running_balance: "running_balance",
  share: "share",
  network_error: "network_error",
  copy_link: "copy_link",
  delete_entry: "delete_entry",
  delete_entry_confirm: "delete_entry_confirm",
  delete_entry_warning: "delete_entry_warning",
  edit_entry: "edit_entry",
  update_entry: "update_entry",
  invalid_entry: "invalid_entry",
  entry_not_found: "entry_not_found",
  invalid_entry_type: "invalid_entry_type",
  invalid_amount: "invalid_amount",
  invalid_date: "invalid_date",
  photo_size_error: "photo_size_error",
  invalid_image_format: "invalid_image_format",
  photo_upload_failed: "photo_upload_failed",
  update_failed: "update_failed",


    amount: "amount",
  photo_max: "photo_max",
  change_photo: "change_photo",
  add_entry_title: "add_entry_title",
  save_entry: "save_entry",
  add_photo_label: "add_photo_label",
  photo: "photo",
  amount_hint: "amount_hint",
  note_hint: "note_hint",
  failed_to_add_entry: "failed_to_add_entry",
  image_too_large_4mb: "image_too_large_4mb",
  share_coming_soon: "share_coming_soon",
  image_load_failed: "image_load_failed",
  select_date: "select_date",
  photo_max_2mb: "photo_max_2mb",

  // PDF
  owner_name: "owner_name",
  customer_ledger_statement: "customer_ledger_statement",
  supplier_ledger_statement: "supplier_ledger_statement",
  phone: "phone",
  opening_balance: "opening_balance",
  closing_balance: "closing_balance",
  transaction_details: "transaction_details",
  particulars: "particulars",
  credit_short: "credit_short",
  debit_short: "debit_short",
  generated_by: "generated_by",
  data_not_available_for_pdf: "data_not_available_for_pdf",
  report_for_customer: "report_for_customer",
  could_not_load_business_profile: "could_not_load_business_profile",
  final_balance: "final_balance",
  amount_received: "amount_received",
  pdf_generation_error: "pdf_generation_error",
  debit_minus: "debit_minus",
  credit_plus: "credit_plus",
  customer_report: "customer_report",
  print_download: "print_download",
  total_get: "total_get",
  total_give: "total_give",
  report_for: "report_for",
  period: "period",
  report_generated_by: "report_generated_by",
  all_time: "all_time",
  get: "get",
  give: "give",

  // ACCOUNT
  account: "account",
  add_business: "add_business",
  add_owner: "add_owner",
  business: "business",
  staff: "staff",
  items: "items",
  bills: "bills",
  dairy: "dairy",
  cashbook: "cashbook",
  help_support: "help_support",
  about_app: "about_app",
  invite_friends: "invite_friends",
  privacy_policy: "privacy_policy",
  disclaimer: "disclaimer",
  share_message: "share_message",
  share_subject: "share_subject",

  // STAFF
  staff_details: "staff_details",
  staff_question: "staff_question",
  add_staff: "add_staff",
  staff_name: "staff_name",
  permissions: "permissions",
  stop_staff: "stop_staff",
  stop_staff_desc: "stop_staff_desc",
  delete_staff: "delete_staff",
  delete_staff_desc: "delete_staff_desc",
  add_staff_to_manage: "add_staff_to_manage",

  // NAVBAR
  home: "home",
  more: "more",

  // ADD PARTY
  add_party: "add_party",
  address_optional: "address_optional",
  gst_optional: "gst_optional",
  add_supplier: "add_supplier",
  name_required: "name_required",
  edit: "edit",

  // BOOK PROFILE
  book_profile: "book_profile",
  personal_info: "personal_info",
  business_info: "business_info",
  financial_info: "financial_info",
  staff_info: "staff_info",

    name: "name",
  supplier_name: "supplier_name",
  add_name: "add_name",
  registered_number: "registered_number",
  add_mobile: "add_mobile",
  business_name: "business_name",
  business_address: "business_address",
  add_address: "add_address",
  gstin: "gstin",
  bank_account: "bank_account",
  add_details: "add_details",
  details: "details",
  add_photo: "add_photo",
  profile_strength: "profile_strength",
  customer_profile: "customer_profile",
  supplier_profile: "supplier_profile",
  address: "address",
  type: "type",
  customer: "customer",
  supplier: "supplier",
  delete_customer: "delete_customer",
  delete_supplier: "delete_supplier",
  delete_customer_desc: "delete_customer_desc",
  delete_supplier_desc: "delete_supplier_desc",
  add_gstin: "add_gstin",
  supplier_report: "supplier_report",
  sms_settings: "sms_settings",
  sms_settings_desc: "sms_settings_desc",
  edit_customer_details: "edit_customer_details",
  edit_customer_details_desc: "edit_customer_details_desc",

  // PROFILE STRENGTH
  weak: "weak",
  average: "average",
  good: "good",
  strong: "strong",

  // STAFF & PERMISSIONS

  // Buttons
  save_staff: "save_staff",
  update_staff: "update_staff",
  cancel: "cancel",

  // Empty / loading
  no_staff_found: "no_staff_found",

  // Staff card
  active: "active",
  stopped: "stopped",
  start: "start",
  stop: "stop",

  // Permissions
  view: "view",
  add: "add",
  delete: "delete",

  // Bottom sheet / form
  mobile_number: "mobile_number",
  add_staff_title: "add_staff_title",
  edit_staff_title: "edit_staff_title",

  // Delete dialog
  staff_deleted_success: "staff_deleted_success",

  // Generic
  yes: "yes",
  no: "no",
  khatabook_deleted_success: "khatabook_deleted_success",
  something_went_wrong: "something_went_wrong",

  // Business Logo
  business_logo: "business_logo",
  choose_photo: "choose_photo",
  save_logo: "save_logo",
  upload_error: "upload_error",
  upload_type_err: "upload_type_err",

  // Edit Field
  enter_name: "enter_name",
  enter_mobile: "enter_mobile",
  enter_business: "enter_business",
  enter_address: "enter_address",

  // GSTIN
  gstin_details: "gstin_details",
  gstin_number: "gstin_number",
  enter_gstin: "enter_gstin",
  gstin_note: "gstin_note",
  save_gstin: "save_gstin",

    // BANK
  bank_details: "bank_details",
  bank_name: "bank_name",
  enter_bank_name: "enter_bank_name",
  account_number: "account_number",
  enter_account_no: "enter_account_no",
  ifsc_code: "ifsc_code",
  enter_ifsc: "enter_ifsc",
  bank_note: "bank_note",
  save_bank_details: "save_bank_details",
  invalid_bank_details: "invalid_bank_details",

  // STAFF
  confirm: "confirm",

  // ERROR / COMMON
  invalid_gstin: "invalid_gstin",
  failed_to_save: "failed_to_save",

  // Cashbook
  cash: "cash",
  online: "online",
  total_balance_cashbook: "total_balance_cashbook",
  today_balance: "today_balance",
  view_report: "view_report",
  out_entry: "out_entry",
  in_entry: "in_entry",
  add_first_entry: "add_first_entry",
  attach_bill: "attach_bill",
  enter_amount: "enter_amount",
  empty_title: "empty_title",
  saving: "saving",
  save_failed: "save_failed",
  server_error: "server_error",
  ok: "ok",
  error: "error",
  payment_mode: "payment_mode",
  entry_saved_offline_and_will_be_synced_later: "entry_saved_offline_and_will_be_synced_later",
  entry_waiting_to_be_synced: "entry_waiting_to_be_synced",
  cash_entry: "cash_entry",
  cash_in: "cash_in",
  cash_out: "cash_out",
  cashbook_status: "cashbook_status",
  real_time_cash_online: "real_time_cash_online",

  // Cashbook Specific
  entry_is_backed_up: "entry_is_backed_up",
  safe_and_secure: "safe_and_secure",
  invalid_image_format_cashbook_popup: "invalid_image_format_cashbook_popup",
  photo_size_error_cashbook_popup: "photo_size_error_cashbook_popup",
  selected_image: "selected_image",

  // Cashbook Report Screen
  cashbook_report_title: "cashbook_report_title",
  date_range: "date_range",
  single_day: "single_day",
  this_week: "this_week",
  this_month: "this_month",
  last_week: "last_week",
  last_month: "last_month",
  all: "all",
  to: "to",
  no_entries_found_period: "no_entries_found_period",
  daily_balance_short: "daily_balance_short",
  download_pdf: "download_pdf",
  pdf_download_not_implemented: "pdf_download_not_implemented",

  // Cashbook Report Day Screen
  daily_details: "daily_details",
  no_entries_on_this_day: "no_entries_on_this_day",
  add_entries_help: "add_entries_help",
  add_entry_to: "add_entry_to",
  add_entry: "add_entry",
  could_not_load_report: "could_not_load_report",

  // Entry Details Screen
  delete_failed: "delete_failed",
  photo_max_4mb: "photo_max_4mb",
  entry_of_amount: "entry_of_amount",

  // PDF
  daily_summary: "daily_summary",
  my_business: "my_business",
  total_in: "total_in",
  total_out: "total_out",
  no_data_available: "no_data_available",

  // Months
  month_1: "month_1",
  month_2: "month_2",
  month_3: "month_3",
  month_4: "month_4",
  month_5: "month_5",
  month_6: "month_6",
  month_7: "month_7",
  month_8: "month_8",
  month_9: "month_9",
  month_10: "month_10",
  month_11: "month_11",
  month_12: "month_12",

  // Customer Supplier Add
  add_customer: "add_customer",
  customer_already_exists: "customer_already_exists",
  supplier_already_exists: "supplier_already_exists",

  // Cashbook Empty State
  cashbook_welcome: "cashbook_welcome",
  add_first_entry_btn: "add_first_entry_btn",
  add_customers_collect_faster: "add_customers_collect_faster",

  // Permissions
  permission_denied_title: "permission_denied_title",
  permission_denied_content: "permission_denied_content",
  permission_denied_settings_button: "permission_denied_settings_button",
  permission_denied_cancel_button: "permission_denied_cancel_button",
  permission_denied_generic_message: "permission_denied_generic_message",

    // Contact Picker
  permission_required: "permission_required",
  contacts_permission_message: "contacts_permission_message",
  failed_to_open_contacts_picker: "failed_to_open_contacts_picker",
  permission_denied_to_read_contacts: "permission_denied_to_read_contacts",

  // Add Item Screen
  tax_exempted: "tax_exempted",
  no_gst: "no_gst",
  select_photo: "select_photo",
  gallery: "gallery",
  camera: "camera",
  please_enter_item_name: "please_enter_item_name",
  failed_to_upload_image: "failed_to_upload_image",
  item_updated_successfully: "item_updated_successfully",
  item_saved_successfully: "item_saved_successfully",
  failed_to_update_item: "failed_to_update_item",
  failed_to_save_item: "failed_to_save_item",
  confirm_deletion: "confirm_deletion",
  are_you_sure_delete_item: "are_you_sure_delete_item",
  item_deleted_successfully: "item_deleted_successfully",
  failed_to_delete_item: "failed_to_delete_item",
  edit_item: "edit_item",
  edit_service: "edit_service",
  add_product: "add_product",
  add_service: "add_service",
  add_hsn_and_gst_details: "add_hsn_and_gst_details",
  hsn: "hsn",
  enter_hsn: "enter_hsn",
  gst_rate_percent: "gst_rate_percent",
  enter_gst_rate: "enter_gst_rate",
  primary_unit: "primary_unit",
  enter_item_name_here: "enter_item_name_here",
  sale_price: "sale_price",
  purchase_price: "purchase_price",
  tax_included: "tax_included",
  opening_stock: "opening_stock",
  low_stock_alert: "low_stock_alert",
  as_of_date: "as_of_date",
  enter_price: "enter_price",
  enter_count: "enter_count",
  save_item: "save_item",
  delete_item: "delete_item",
  select_unit: "select_unit",
  search_unit: "search_unit",
  add_gst_rate: "add_gst_rate",
  add_custom_tax: "add_custom_tax",
  custom_tax: "custom_tax",
  gst: "gst",
  cess: "cess",
  add_hsn_code: "add_hsn_code",
  hsn_code: "hsn_code",
  item_name: "item_name",
  enter_hsn_code: "enter_hsn_code",
  enter_item_name: "enter_item_name",
  results: "results",
  no_hsn_code_found: "No HSN code found",
  use: "Use",
  as_hsn_code: "as_hsn_code",
  you_are_offline_please_connect_to_the_internet: "You are offline. Please connect to the internet.",

  // ITEMS SCREEN
  products: "products",
  services: "services",
  add_product_caps: "add_product_caps",
  add_service_caps: "add_service_caps",
  add_items_and_get_started: "add_items_and_get_started",
  manage_stock_feature: "manage_stock_feature",
  detailed_stock_history_feature: "detailed_stock_history_feature",
  track_prices_and_profits_feature: "track_prices_and_profits_feature",
  search_items: "search_items",
  my_items: "my_items",
  item_added: "item_added",
  low_stock: "low_stock",
  current_stock: "current_stock",
  stock_history: "stock_history",
  stock_in: "stock_in",
  stock_out: "stock_out",
  add_services_and_get_started: "add_services_and_get_started",
  manage_services_feature: "manage_services_feature",
  save_sac_and_gst_feature: "save_sac_and_gst_feature",
  track_sales_and_bills_feature: "track_sales_and_bills_feature",
  net_monthly_sales: "net_monthly_sales",
  rupees: "rupees",
  search_services: "search_services",
  my_services: "my_services",
  service_price: "service_price",
  unit: "unit",
  enter_purchased_quantity: "enter_purchased_quantity",
  enter_sold_quantity: "enter_sold_quantity",
  quantity: "quantity",
  add_notes_optional: "add_notes_optional",
  stock_in_caps: "stock_in_caps",
  stock_out_caps: "stock_out_caps",
  total_stock: "total_stock",
  low_stock_items: "low_stock_items",
  all_items: "all_items",
  failed_to_load_items: "failed_to_load_items",

  // Filter & Sort
  filter_by_stock: "filter_by_stock",
  sort_by_name_az: "sort_by_name_az",
  sort_by_name_za: "sort_by_name_za",

  // ADD SERVICE SCREEN
  failed_to_process_image: "failed_to_process_image",
  could_not_pick_image: "could_not_pick_image",
  failed_to_upload_photo: "failed_to_upload_photo",
  failed_to_update_service: "failed_to_update_service",
  failed_to_add_service: "failed_to_add_service",
  are_you_sure_delete_service: "are_you_sure_delete_service",
  failed_to_delete_service: "failed_to_delete_service",
  add_sac_and_gst_details: "add_sac_and_gst_details",
  sac_code: "sac_code",
  enter_sac: "enter_sac",
  enter_service_name_here: "enter_service_name_here",
  please_enter_service_name: "please_enter_service_name",
  tax_included_in_price: "tax_included_in_price",
  delete_service: "delete_service",
  save_changes: "save_changes",

    // ITEM DETAILS SCREEN
  edit_product: "edit_product",
  stock_quantity: "stock_quantity",
  stock_value: "stock_value",

  // SERVICE DETAILS SCREEN
  edit_service_caps: "edit_service_caps",
  service_name: "service_name",
  gst_percent: "gst_percent",
  no_sales_added_for_service: "no_sales_added_for_service",
  zero_percent: "zero_percent",

  // BILLS SCREEN
  bills_add_sale: "bills_add_sale",
  bills_search_sales_hint: "bills_search_sales_hint",
  bills_add_purchase: "bills_add_purchase",
  bills_search_purchases_hint: "bills_search_purchases_hint",
  bills_add_expense: "bills_add_expense",
  bills_search_expenses_hint: "bills_search_expenses_hint",
  bills_start_creating_gst: "bills_start_creating_gst",
  bills_tab_sale: "bills_tab_sale",
  bills_tab_purchase: "bills_tab_purchase",
  bills_tab_expense: "bills_tab_expense",
  bills_monthly_sales: "bills_monthly_sales",
  bills_monthly_purchases: "bills_monthly_purchases",
  bills_view_reports: "bills_view_reports",
  bills_todays_in: "bills_todays_in",
  bills_todays_out: "bills_todays_out",
  bills_cashbook: "bills_cashbook",
  bills_empty_state_title: "bills_empty_state_title",
  bills_empty_state_subtitle: "bills_empty_state_subtitle",
  bills_empty_state_gst_support: "bills_empty_state_gst_support",
  bills_see_sample_invoices: "bills_see_sample_invoices",
  bills_no_matching_found: "bills_no_matching_found",
  bills_payment_in: "bills_payment_in",
  bills_status_fully_paid: "bills_status_fully_paid",
  bills_status_unpaid: "bills_status_unpaid",
  bills_sale_bill: "bills_sale_bill",
  bills_purchase_bill: "bills_purchase_bill",
  bills_expense_bill: "bills_expense_bill",
  bills_more_button: "bills_more_button",
  bills_added_to_ledger: "bills_added_to_ledger",

  // Filter & Sort
  filter_and_sort: "filter_and_sort",
  filter_by_status: "filter_by_status",
  filter_all_bills: "filter_all_bills",
  filter_paid_bills: "filter_paid_bills",
  filter_unpaid_bills: "filter_unpaid_bills",
  sort_by: "sort_by",
  sort_latest_first: "sort_latest_first",
  sort_oldest_first: "sort_oldest_first",
  sort_highest_amount: "sort_highest_amount",
  sort_lowest_amount: "sort_lowest_amount",
  clear_filters: "clear_filters",
  apply_filters: "apply_filters",

  // ADD BILL SCREEN
  add_bill_sale: "add_bill_sale",
  add_bill_purchase: "add_bill_purchase",
  add_bill_expense: "add_bill_expense",
  add_bill_edit_sale_gst_bill: "add_bill_edit_sale_gst_bill",
  add_bill_sale_gst_bill: "add_bill_sale_gst_bill",
  add_bill_edit_purchase_gst_bill: "add_bill_edit_purchase_gst_bill",
  add_bill_purchase_gst_bill: "add_bill_purchase_gst_bill",
  add_bill_edit_expense: "add_bill_edit_expense",
  add_bill_expense_title: "add_bill_expense_title",
  add_bill_edit_sale_bill: "add_bill_edit_sale_bill",
  add_bill_sale_bill: "add_bill_sale_bill",
  add_bill_edit_purchase_bill: "add_bill_edit_purchase_bill",
  add_bill_purchase_bill: "add_bill_purchase_bill",
  add_bill_sale_bill_no: "add_bill_sale_bill_no",
  add_bill_purchase_bill_no: "add_bill_purchase_bill_no",
  add_bill_expense_no: "add_bill_expense_no",
  add_bill_update_sale_bill: "add_bill_update_sale_bill",
  add_bill_generate_sale_bill: "add_bill_generate_sale_bill",
  add_bill_update_purchase_bill: "add_bill_update_purchase_bill",
  add_bill_generate_purchase_bill: "add_bill_generate_purchase_bill",
  add_bill_update_expense: "add_bill_update_expense",
  add_bill_generate_expense: "add_bill_generate_expense",
  add_bill_select_customer_error: "add_bill_select_customer_error",
  add_bill_add_item_error: "add_bill_add_item_error",
  add_bill_updated_successfully: "add_bill_updated_successfully",
  add_bill_saved_successfully: "add_bill_saved_successfully",
  add_bill_failed_to_save: "add_bill_failed_to_save",
  add_bill_error_occurred: "add_bill_error_occurred",
  add_bill_bill_to: "add_bill_bill_to",
  add_bill_search_parties: "add_bill_search_parties",
  add_bill_add_new_party: "add_bill_add_new_party",
  add_bill_edit_party_details: "add_bill_edit_party_details",
  add_bill_items: "add_bill_items",
  add_bill_enter_items_from_inventory: "add_bill_enter_items_from_inventory",
  add_bill_add_new_item: "add_bill_add_new_item",
  add_bill_n_items: "add_bill_n_items",
  add_bill_edit_or_add_items: "add_bill_edit_or_add_items",
  add_bill_discount: "add_bill_discount",
  add_bill_extra_discount: "add_bill_extra_discount",
  add_bill_item_subtotal: "add_bill_item_subtotal",
  add_bill_round_off: "add_bill_round_off",
  add_bill_bill_amount: "add_bill_bill_amount",
  add_bill_optional_fields: "add_bill_optional_fields",
  add_bill_printed_on_invoice: "add_bill_printed_on_invoice",
  add_bill_custom_fields: "add_bill_custom_fields",
  add_bill_party_address: "add_bill_party_address",
  add_bill_your_address: "add_bill_your_address",
  add_bill_terms_conditions: "add_bill_terms_conditions",
  add_bill_private_to_you: "add_bill_private_to_you",
  add_bill_add_notes_photos: "add_bill_add_notes_photos",
  add_bill_n_photos_added: "add_bill_n_photos_added",
  add_bill_balance_due: "add_bill_balance_due",
  cgst: "cgst",
  sgst: "sgst",
  pending_bill_no: "pending_bill_no",
  add_bill_add_due_to_ledger: "add_bill_add_due_to_ledger",
  add_bill_select_supplier_error: "add_bill_select_supplier_error",

    // BILL DETAILS SCREEN
  bill_details_error_id_missing: "bill_details_error_id_missing",
  bill_details_failed_to_load: "bill_details_failed_to_load",
  bill_details_delete_confirmation_title: "bill_details_delete_confirmation_title",
  bill_details_delete_confirmation_content: "bill_details_delete_confirmation_content",
  bill_details_delete_button: "bill_details_delete_button",
  bill_details_deleted_successfully: "bill_details_deleted_successfully",
  bill_details_failed_to_delete: "bill_details_failed_to_delete",
  bill_details_generating_pdf: "bill_details_generating_pdf",
  bill_details_share_text: "bill_details_share_text",
  bill_details_failed_to_share: "bill_details_failed_to_share",
  bill_details_title: "bill_details_title",
  bill_details_could_not_load: "bill_details_could_not_load",
  bill_details_status: "bill_details_status",
  bill_details_status_pending: "bill_details_status_pending",
  bill_details_no_items: "bill_details_no_items",
  bill_details_view_pdf: "bill_details_view_pdf",

  // EXPENSE DETAILS SCREEN
  expense_number_prefix: "expense_number_prefix",
  edit_expense: "edit_expense",
  delete_expense: "delete_expense",
  deleting_expense: "deleting_expense",
  expense_deleted_successfully: "expense_deleted_successfully",
  failed_to_delete_expense: "failed_to_delete_expense",
  edit_feature_coming_soon: "edit_feature_coming_soon",
  delete_expense_confirmation: "delete_expense_confirmation",

  // INVOICE PREVIEW SCREEN
  invoice_preview_title: "invoice_preview_title",
  invoice_preview_generating: "invoice_preview_generating",
  invoice_preview_failed: "invoice_preview_failed",
  invoice_preview_preparing_print: "invoice_preview_preparing_print",
  invoice_preview_failed_print: "invoice_preview_failed_print",
  invoice_preview_delete_title: "invoice_preview_delete_title",
  invoice_preview_delete_content: "invoice_preview_delete_content",
  invoice_preview_deleted_successfully: "invoice_preview_deleted_successfully",
  invoice_preview_failed_delete: "invoice_preview_failed_delete",
  invoice_preview_theme_premium: "invoice_preview_theme_premium",
  invoice_preview_theme_thermal: "invoice_preview_theme_thermal",
  invoice_preview_theme_basic: "invoice_preview_theme_basic",
  invoice_preview_theme_new: "invoice_preview_theme_new",
  invoice_preview_download: "invoice_preview_download",
  invoice_preview_share: "invoice_preview_share",
  invoice_preview_print: "invoice_preview_print",
  invoice_preview_create_new: "invoice_preview_create_new",
  invoice_preview_done: "invoice_preview_done",

  // PAYMENT DETAILS SCREEN
  payment_details_title_in: "payment_details_title_in",
  payment_details_title_out: "payment_details_title_out",
  payment_details_share_text: "payment_details_share_text",
  payment_details_failed_to_share: "payment_details_failed_to_share",
  payment_details_adjusted_invoices: "payment_details_adjusted_invoices",

  // SAMPLE INVOICES SCREEN
  sample_invoice_title: "sample_invoice_title",
  premium_invoice: "premium_invoice",
  thermal_invoice: "thermal_invoice",
  basic_invoice: "basic_invoice",
  use_this_template: "use_this_template",

  // ITEM SELECT SHEET
  item_select_not_enough_stock: "item_select_not_enough_stock",
  item_select_no_items_found: "item_select_no_items_found",
  item_select_item_discount: "item_select_item_discount",
  item_select_final_price: "item_select_final_price",
  item_select_gst_rate: "item_select_gst_rate",
  item_select_item_single: "item_select_item_single",
  item_select_item_plural: "item_select_item_plural",
  item_select_continue: "item_select_continue",
  item_select_add_items_to_invoice: "item_select_add_items_to_invoice",
  item_select_search_created_items: "item_select_search_created_items",
  item_select_add_new: "item_select_add_new",

  // QUICK ADD ITEM DIALOG
  add_more_details: "add_more_details",
  add_item_to_bill: "add_item_to_bill",
  please_enter_value: "please_enter_value",
  please_enter_valid_number: "please_enter_valid_number",

  // CUSTOM FIELDS DIALOG
  add_bill_custom_fields_subtitle: "add_bill_custom_fields_subtitle",
  add_bill_add_new_custom_field: "add_bill_add_new_custom_field",
  add_bill_max_custom_fields: "add_bill_max_custom_fields",
  add_bill_custom_field_name_hint: "add_bill_custom_field_name_hint",
  add_bill_custom_field_value_hint: "add_bill_custom_field_value_hint",

  // EDIT PRICE DIALOG
  edit_price_gst_details: "edit_price_gst_details",
  edit_price_enter_discount_hint: "edit_price_enter_discount_hint",
  rupee: "rupee",
  percentage: "percentage",
  rate: "rate",
  tax: "tax",

  // ADDRESS SCREEN
  address_business_address_title: "address_business_address_title",
  address_flat_building_number: "address_flat_building_number",
  address_enter_flat_building_number: "address_enter_flat_building_number",
  address_area_locality: "address_area_locality",
  address_enter_area_locality: "address_enter_area_locality",
  address_city: "address_city",
  address_enter_city: "address_enter_city",
  address_state: "address_state",
  address_enter_state: "address_enter_state",
  address_pincode: "address_pincode",
  address_enter_pincode: "address_enter_pincode",
  address_invalid_pincode: "address_invalid_pincode",

  // PARTY ADDRESS SCREEN
  party_address_title: "party_address_title",
  party_address_billing_address: "party_address_billing_address",
  party_address_shipping_same_as_billing: "party_address_shipping_same_as_billing",

  // ADD NOTES AND PHOTOS DIALOG
  add_notes_and_photos_title: "add_notes_and_photos_title",
  add_notes_and_photos_subtitle: "add_notes_and_photos_subtitle",
  add_notes_and_photos_notes_hint: "add_notes_and_photos_notes_hint",
  photos_access_permanently_denied: "photos_access_permanently_denied",
  photos_access_denied: "photos_access_denied",
  open_settings: "open_settings",

  // TERMS AND CONDITIONS DIALOG
  terms_and_conditions_title: "terms_and_conditions_title",
  terms_and_conditions_hint: "terms_and_conditions_hint",

    // KHATA TABS
  customers: "customers",
  suppliers: "suppliers",
  search_supplier: "search_supplier",
  add_first_customer: "add_first_customer",
  add_first_supplier: "add_first_supplier",
  add_new_customer_prompt: "add_new_customer_prompt",
  add_new_suppliers_prompt: "add_new_suppliers_prompt",

  // CASHBOOK HELP DIALOG
  cashbook_help_title: "cashbook_help_title",
  cashbook_help_in_title: "cashbook_help_in_title",
  cashbook_help_in_desc: "cashbook_help_in_desc",
  cashbook_help_out_title: "cashbook_help_out_title",
  cashbook_help_out_desc: "cashbook_help_out_desc",
  cashbook_help_total_balance_title: "cashbook_help_total_balance_title",
  cashbook_help_total_balance_desc: "cashbook_help_total_balance_desc",
  cashbook_help_today_balance_title: "cashbook_help_today_balance_title",
  cashbook_help_today_balance_desc: "cashbook_help_today_balance_desc",
  cashbook_help_report_title: "cashbook_help_report_title",
  cashbook_help_report_desc: "cashbook_help_report_desc",

  // ADD EXPENSE SCREEN
  expense_amount: "expense_amount",
  select_category: "select_category",
  select_expense_category: "select_expense_category",
  expense_items_warning: "expense_items_warning",
  add_expense_items_optional: "add_expense_items_optional",
  expense_items_feature_coming_soon: "expense_items_feature_coming_soon",
  notes_and_photos_optional: "notes_and_photos_optional",
  photos_added: "photos_added",
  save_expense_amount: "save_expense_amount",
  update_expense_amount: "update_expense_amount",
  expense_saved_successfully: "expense_saved_successfully",
  expense_updated_successfully: "expense_updated_successfully",
  failed_to_save_expense: "failed_to_save_expense",
  enter_valid_amount: "enter_valid_amount",
  please_select_expense_category: "please_select_expense_category",
  category: "category",

  // EXPENSE CATEGORIES
  cat_rent: "cat_rent",
  cat_salaries: "cat_salaries",
  cat_electricity: "cat_electricity",
  cat_water: "cat_water",
  cat_internet: "cat_internet",
  cat_office: "cat_office",
  cat_marketing: "cat_marketing",
  cat_travel: "cat_travel",
  cat_fuel: "cat_fuel",
  cat_food: "cat_food",
  cat_repairs: "cat_repairs",
  cat_election: "cat_election",
  cat_taxes: "cat_taxes",
  cat_insurance: "cat_insurance",
  cat_cleaning: "cat_cleaning",
  cat_delivery: "cat_delivery",
  cat_software: "cat_software",
  cat_furniture: "cat_furniture",
  cat_other: "cat_other",

  // EXPENSE EMPTY STATE
  expense_empty_title: "expense_empty_title",
  expense_empty_subtitle: "expense_empty_subtitle",
  expense_empty_footer: "expense_empty_footer",

  // BILL REPORT SCREEN
  bill_report_title: "bill_report_title",
  report_for_period: "report_for_period",
  select_date_range: "select_date_range",
  total_sales: "total_sales",
  total_purchases: "total_purchases",
  total_expenses: "total_expenses",
  net_profit: "net_profit",
  net_loss: "net_loss",
  all_transactions: "all_transactions",
  no_transactions_found_period: "no_transactions_found_period",
  expense_fallback_category: "expense_fallback_category",

  // SALES REPORT SCREEN
  sales_report: "sales_report",
  transactions: "transactions",
  net_sale: "net_sale",
  unpaid_balance: "unpaid_balance",
  sales_report_share_text: "sales_report_share_text",

  // PURCHASE REPORT SCREEN
  purchase_report: "purchase_report",
  net_purchase: "net_purchase",
  purchase_report_share_text: "purchase_report_share_text",

  // KHATA FILTER & SORT
  filter_by_balance: "filter_by_balance",
  filter_all_parties: "filter_all_parties",

  // LOGOUT
  logout_confirm: "logout_confirm",
  confirm_logout: "confirm_logout",

  // DEVICES
  manage_devices: "manage_devices",
  active_devices: "active_devices",
  logout_device: "logout_device",
  logout_device_confirm: "logout_device_confirm",
  device_logged_out: "device_logged_out",
  no_active_devices: "no_active_devices",
  last_login: "last_login",
  this_device: "this_device",
  loading_devices: "loading_devices",

    // SMS SETTINGS
  send_whatsapp_messages: "send_whatsapp_messages",
  enabled: "enabled",
  disabled: "disabled",
  manage_whatsapp_settings: "manage_whatsapp_settings",
  recharge_and_control: "recharge_and_control",
  wa_message_sent: "wa_message_sent",
  wa_message_pending: "wa_message_pending",
  wa_message_disabled: "wa_message_disabled",
  wa_message_failed: "wa_message_failed",
  wa_no_credits: "wa_no_credits",
  
  // DASHBOARD EMPTY STATE
  pro_tip: "pro_tip",
  dashboard_empty_tip: "dashboard_empty_tip",
  select_entry: "select_entry",
  entry_details_appear: "entry_details_appear",

  // PREMIUM
  plan_standard_name: "plan_standard_name",
  plan_ads_free_name: "plan_ads_free_name",
  plan_premium_name: "plan_premium_name",
  plan_recommended_tag: "plan_recommended_tag",
  plan_duration_30_days: "plan_duration_30_days",
  plan_duration_180_days: "plan_duration_180_days",
  plan_duration_365_days: "plan_duration_365_days",
  plan_duration_30_days_badge: "plan_duration_30_days_badge",
  plan_save_20_percent: "plan_save_20_percent",
  plan_best_value_badge: "plan_best_value_badge",
  plan_best_value_plan_tag: "plan_best_value_plan_tag",
  plan_most_popular_save: "plan_most_popular_save",
  plan_save_amount_tag: "plan_save_amount_tag",
  duration_1_month: "duration_1_month",
  duration_6_months: "duration_6_months",
  duration_12_months: "duration_12_months",
  plan_save_text: "plan_save_text",
  benefit_no_ads: "benefit_no_ads",
  benefit_support: "benefit_support",
  benefit_all_ads_free: "benefit_all_ads_free",
  benefit_multiple_devices: "benefit_multiple_devices",
  benefit_desktop_access: "benefit_desktop_access",
  benefit_create_bills: "benefit_create_bills",
  benefit_defaulters_list: "benefit_defaulters_list",
  benefit_organize_lists: "benefit_organize_lists",
  benefit_manage_stocks: "benefit_manage_stocks",
  benefit_financial_reports: "benefit_financial_reports",
  benefit_dual_backup: "benefit_dual_backup",
  benefit_unlimited_entry: "benefit_unlimited_entry",
  benefit_unlimited_transactions: "benefit_unlimited_transactions",
  benefit_unlimited_sms: "benefit_unlimited_sms",
  benefit_dairy_management: "benefit_dairy_management",
  benefit_refer_earn: "benefit_refer_earn",
  my_subscription_title: "my_subscription_title",
  premium_plans_title: "premium_plans_title",
  active_badge_label: "active_badge_label",
  expires_on_label: "expires_on_label",
  expired_badge_label: "expired_badge_label",
  expired_on_label: "expired_on_label",
  extend_plan_label: "extend_plan_label",
  days_remaining_label: "days_remaining_label",
  secure_checkout_label: "secure_checkout_label",
  upgrade_button: "upgrade_button",
  downgrade_button: "downgrade_button",
  item_sales_report: "item_sales_report",
  total_qty_sold: "total_qty_sold",
  units: "units",
  nos: "nos",
  sold: "sold",
  bought: "bought",
  profit: "profit",
  loss: "loss",

  // REPORTS DASHBOARD
  business_reports: "business_reports",
  business_reports_desc: "business_reports_desc",
  ledger_cashbook_reports: "ledger_cashbook_reports",
  billing_inventory_reports: "billing_inventory_reports",
  customer_ledger_statement_report: "customer_ledger_statement_report",
  customer_ledger_report_desc: "customer_ledger_report_desc",
  supplier_ledger_statement_report: "supplier_ledger_statement_report",
  supplier_ledger_report_desc: "supplier_ledger_report_desc",
  cashbook_report_desc: "cashbook_report_desc",
  sales_report_desc: "sales_report_desc",
  purchase_report_desc: "purchase_report_desc",
  bills_summary_report: "bills_summary_report",
  bills_summary_report_desc: "bills_summary_report_desc",
  item_stock_sales_report: "item_stock_sales_report",
  item_stock_sales_report_desc: "item_stock_sales_report_desc",
  select_party: "select_party",
  search_placeholder: "search_placeholder",
  back_to_dashboard: "back_to_dashboard",
  loading_report_data: "loading_report_data",
  no_parties_found: "no_parties_found",
  select_customer: "select_customer",
  select_supplier: "select_supplier",
  premium_feature: "premium_feature",
  premium_lock_desc: "premium_lock_desc",
  upgrade_to_premium: "upgrade_to_premium",

  // Business Profile & Online Marketplace
  biz_profile__marketplace_settings: "biz_profile__marketplace_settings",
  biz_profile__online_business_toggle: "biz_profile__online_business_toggle",
  biz_profile__online_business_active: "biz_profile__online_business_active",
  biz_profile__online_business_offline: "biz_profile__online_business_offline",
  biz_profile__gps_pending_badge: "biz_profile__gps_pending_badge",
  biz_profile__online_business_sub_active: "biz_profile__online_business_sub_active",
  biz_profile__online_business_sub_offline: "biz_profile__online_business_sub_offline",
  biz_profile__know_benefits_btn: "biz_profile__know_benefits_btn",
  biz_profile__benefits_modal_title: "biz_profile__benefits_modal_title",
  biz_profile__benefits_step1_title: "biz_profile__benefits_step1_title",
  biz_profile__benefits_step1_desc: "biz_profile__benefits_step1_desc",
  biz_profile__benefits_step2_title: "biz_profile__benefits_step2_title",
  biz_profile__benefits_step2_desc: "biz_profile__benefits_step2_desc",
  biz_profile__benefits_step3_title: "biz_profile__benefits_step3_title",
  biz_profile__benefits_step3_desc: "biz_profile__benefits_step3_desc",
  biz_profile__benefits_btn_got_it: "biz_profile__benefits_btn_got_it",
  biz_profile__autofill_btn_title: "biz_profile__autofill_btn_title",
  biz_profile__autofill_btn_sub: "biz_profile__autofill_btn_sub",
  biz_profile__autofill_searching: "biz_profile__autofill_searching",
  biz_profile__state_lbl: "biz_profile__state_lbl",
  biz_profile__state_add: "biz_profile__state_add",
  biz_profile__state_placeholder: "biz_profile__state_placeholder",
  biz_profile__city_lbl: "biz_profile__city_lbl",
  biz_profile__city_add: "biz_profile__city_add",
  biz_profile__city_placeholder: "biz_profile__city_placeholder",
  biz_profile__area_lbl: "biz_profile__area_lbl",
  biz_profile__area_add: "biz_profile__area_add",
  biz_profile__area_placeholder: "biz_profile__area_placeholder",
  biz_profile__pincode_lbl: "biz_profile__pincode_lbl",
  biz_profile__pincode_add: "biz_profile__pincode_add",
  biz_profile__pincode_placeholder: "biz_profile__pincode_placeholder",
  biz_profile__tagline_lbl: "biz_profile__tagline_lbl",
  biz_profile__tagline_add: "biz_profile__tagline_add",
  biz_profile__tagline_placeholder: "biz_profile__tagline_placeholder",
  biz_profile__gps_lbl: "biz_profile__gps_lbl",
  biz_profile__gps_not_set: "biz_profile__gps_not_set",
  biz_profile__gps_update_btn: "biz_profile__gps_update_btn",
  biz_profile__gps_get_btn: "biz_profile__gps_get_btn",
  biz_profile__gps_searching: "biz_profile__gps_searching",
  biz_profile__gps_live_warning: "biz_profile__gps_live_warning",
  biz_profile__gps_turn_on_toast: "biz_profile__gps_turn_on_toast",
  biz_profile__gps_permission_denied_toast: "biz_profile__gps_permission_denied_toast",
  biz_profile__gps_permission_settings_toast: "biz_profile__gps_permission_settings_toast",
  biz_profile__gps_autofill_success_toast: "biz_profile__gps_autofill_success_toast",
  biz_profile__gps_error_toast: "biz_profile__gps_error_toast",
  biz_market_video_guide_title: "biz_market_video_guide_title",
  biz_market_video_guide_sub: "biz_market_video_guide_sub",
  item_video_guide_btn_sub: "item_video_guide_btn_sub",
  service_video_guide_btn_sub: "service_video_guide_btn_sub",
  item_marketplace_title: "item_marketplace_title",
  item_marketplace_sub_active: "item_marketplace_sub_active",
  item_marketplace_sub_inactive: "item_marketplace_sub_inactive",
  service_marketplace_sub_active: "service_marketplace_sub_active",
  service_marketplace_sub_inactive: "service_marketplace_sub_inactive",
  item_category_lbl: "item_category_lbl",
  change_btn: "change_btn",
  item_discount_price_lbl: "item_discount_price_lbl",
  item_discount_price_hint: "item_discount_price_hint",
  service_discount_price_lbl: "service_discount_price_lbl",
  service_discount_price_hint: "service_discount_price_hint",
  item_desc_lbl: "item_desc_lbl",
  item_desc_hint: "item_desc_hint",
  service_desc_lbl: "service_desc_lbl",
  service_desc_hint: "service_desc_hint",
  market_seo_badge: "market_seo_badge",
  category_picker_title: "category_picker_title",
  category_picker_sub_item: "category_picker_sub_item",
  category_picker_sub_service: "category_picker_sub_service",
  category_search_hint: "category_search_hint",
  no_category_found: "no_category_found",
  nothing_found_for: "nothing_found_for",
  cat_title_general: "cat_title_general",
  cat_sub_general: "cat_sub_general",
  cat_title_grocery: "cat_title_grocery",
  cat_sub_grocery: "cat_sub_grocery",
  cat_title_dairy: "cat_title_dairy",
  cat_sub_dairy: "cat_sub_dairy",
  cat_title_fruits_veg: "cat_title_fruits_veg",
  cat_sub_fruits_veg: "cat_sub_fruits_veg",
  cat_title_sweets_bakery: "cat_title_sweets_bakery",
  cat_sub_sweets_bakery: "cat_sub_sweets_bakery",
  cat_title_restaurant_food: "cat_title_restaurant_food",
  cat_sub_restaurant_food: "cat_sub_restaurant_food",
  cat_title_pharmacy_medical: "cat_title_pharmacy_medical",
  cat_sub_pharmacy_medical: "cat_sub_pharmacy_medical",
  cat_title_agriculture_seeds: "cat_title_agriculture_seeds",
  cat_sub_agriculture_seeds: "cat_sub_agriculture_seeds",
  cat_title_animal_feed: "cat_title_animal_feed",
  cat_sub_animal_feed: "cat_sub_animal_feed",
  cat_title_electronics_mobile: "cat_title_electronics_mobile",
  cat_sub_electronics_mobile: "cat_sub_electronics_mobile",
  cat_title_electrical_appliances: "cat_title_electrical_appliances",
  cat_sub_electrical_appliances: "cat_sub_electrical_appliances",
  cat_title_clothing_garments: "cat_title_clothing_garments",
  cat_sub_clothing_garments: "cat_sub_clothing_garments",
  cat_title_footwear_shoes: "cat_title_footwear_shoes",
  cat_sub_footwear_shoes: "cat_sub_footwear_shoes",
  cat_title_hardware_sanitary: "cat_title_hardware_sanitary",
  cat_sub_hardware_sanitary: "cat_sub_hardware_sanitary",
  cat_title_building_materials: "cat_title_building_materials",
  cat_sub_building_materials: "cat_sub_building_materials",
  cat_title_automobile_parts: "cat_title_automobile_parts",
  cat_sub_automobile_parts: "cat_sub_automobile_parts",
  cat_title_cosmetics_beauty: "cat_title_cosmetics_beauty",
  cat_sub_cosmetics_beauty: "cat_sub_cosmetics_beauty",
  cat_title_stationery_books: "cat_title_stationery_books",
  cat_sub_stationery_books: "cat_sub_stationery_books",
  cat_title_jewellery_gifts: "cat_title_jewellery_gifts",
  cat_sub_jewellery_gifts: "cat_sub_jewellery_gifts",
  cat_title_furniture_decor: "cat_title_furniture_decor",
  cat_sub_furniture_decor: "cat_sub_furniture_decor",
  cat_title_kitchenware_utensils: "cat_title_kitchenware_utensils",
  cat_sub_kitchenware_utensils: "cat_sub_kitchenware_utensils",
  cat_title_toys_sports: "cat_title_toys_sports",
  cat_sub_toys_sports: "cat_sub_toys_sports",
  cat_title_packaging_disposable: "cat_title_packaging_disposable",
  cat_sub_packaging_disposable: "cat_sub_packaging_disposable",
  cat_title_tailoring_boutique: "cat_title_tailoring_boutique",
  cat_sub_tailoring_boutique: "cat_sub_tailoring_boutique",
  cat_title_meat_poultry: "cat_title_meat_poultry",
  cat_sub_meat_poultry: "cat_sub_meat_poultry",
  cat_title_services_repair: "cat_title_services_repair",
  cat_sub_services_repair: "cat_sub_services_repair",
  cat_title_other: "cat_title_other",
  cat_sub_other: "cat_sub_other",
  cat_title_optical_eyewear: "cat_title_optical_eyewear",
  cat_sub_optical_eyewear: "cat_sub_optical_eyewear",
  cat_title_pooja_religious: "cat_title_pooja_religious",
  cat_sub_pooja_religious: "cat_sub_pooja_religious",
  cat_title_watches_accessories: "cat_title_watches_accessories",
  cat_sub_watches_accessories: "cat_sub_watches_accessories",
  cat_title_generalservice: "cat_title_generalservice",
  cat_sub_generalservice: "cat_sub_generalservice",
  cat_title_electronics_tv_repair: "cat_title_electronics_tv_repair",
  cat_sub_electronics_tv_repair: "cat_sub_electronics_tv_repair",
  cat_title_ac_appliances_repair: "cat_title_ac_appliances_repair",
  cat_sub_ac_appliances_repair: "cat_sub_ac_appliances_repair",
  cat_title_electrician_wiring: "cat_title_electrician_wiring",
  cat_sub_electrician_wiring: "cat_sub_electrician_wiring",
  cat_title_plumbing_sanitary: "cat_title_plumbing_sanitary",
  cat_sub_plumbing_sanitary: "cat_sub_plumbing_sanitary",
  cat_title_tailoring_stitching: "cat_title_tailoring_stitching",
  cat_sub_tailoring_stitching: "cat_sub_tailoring_stitching",
  cat_title_mobile_laptop_repair: "cat_title_mobile_laptop_repair",
  cat_sub_mobile_laptop_repair: "cat_sub_mobile_laptop_repair",
  cat_title_automobile_mechanic: "cat_title_automobile_mechanic",
  cat_sub_automobile_mechanic: "cat_sub_automobile_mechanic",
  cat_title_beauty_parlour_salon: "cat_title_beauty_parlour_salon",
  cat_sub_beauty_parlour_salon: "cat_sub_beauty_parlour_salon",
  cat_title_carpenter_woodwork: "cat_title_carpenter_woodwork",
  cat_sub_carpenter_woodwork: "cat_sub_carpenter_woodwork",
  cat_title_painting_whitewash: "cat_title_painting_whitewash",
  cat_sub_painting_whitewash: "cat_sub_painting_whitewash",
  cat_title_construction_civil: "cat_title_construction_civil",
  cat_sub_construction_civil: "cat_sub_construction_civil",
  cat_title_agri_motor_tractor: "cat_title_agri_motor_tractor",
  cat_sub_agri_motor_tractor: "cat_sub_agri_motor_tractor",
  cat_title_cctv_security_install: "cat_title_cctv_security_install",
  cat_sub_cctv_security_install: "cat_sub_cctv_security_install",
  cat_title_cleaning_pest_control: "cat_title_cleaning_pest_control",
  cat_sub_cleaning_pest_control: "cat_sub_cleaning_pest_control",
  cat_title_transport_loading: "cat_title_transport_loading",
  cat_sub_transport_loading: "cat_sub_transport_loading",
  cat_title_photography_video: "cat_title_photography_video",
  cat_sub_photography_video: "cat_sub_photography_video",
  cat_title_events_catering_tent: "cat_title_events_catering_tent",
  cat_sub_events_catering_tent: "cat_sub_events_catering_tent",
  cat_title_education_tuition: "cat_title_education_tuition",
  cat_sub_education_tuition: "cat_sub_education_tuition",
  cat_title_ca_tax_csc_emitra: "cat_title_ca_tax_csc_emitra",
  cat_sub_ca_tax_csc_emitra: "cat_sub_ca_tax_csc_emitra",
  cat_title_healthcare_clinic_lab: "cat_title_healthcare_clinic_lab",
  cat_sub_healthcare_clinic_lab: "cat_sub_healthcare_clinic_lab",
  cat_title_other_service: "cat_title_other_service",
  cat_sub_other_service: "cat_sub_other_service",
  cat_title_transport_taxi: "cat_title_transport_taxi",
  cat_sub_transport_taxi: "cat_sub_transport_taxi",
  cat_title_legal_advocate: "cat_title_legal_advocate",
  cat_sub_legal_advocate: "cat_sub_legal_advocate",
  cat_title_packers_movers: "cat_title_packers_movers",
  cat_sub_packers_movers: "cat_sub_packers_movers",
  cat_title_printing_flex_banner: "cat_title_printing_flex_banner",
  cat_sub_printing_flex_banner: "cat_sub_printing_flex_banner",
  cat_title_gym_fitness_yoga: "cat_title_gym_fitness_yoga",
  cat_sub_gym_fitness_yoga: "cat_sub_gym_fitness_yoga",
  cat_title_cook_maid_househelp: "cat_title_cook_maid_househelp",
  cat_sub_cook_maid_househelp: "cat_sub_cook_maid_househelp",
  item_photo_guide_verified: "item_photo_guide_verified",
  item_photo_guide_why_add: "item_photo_guide_why_add",
  service_photo_guide_why_add: "service_photo_guide_why_add",
  item_photo_guide_desc: "item_photo_guide_desc",
  service_photo_guide_desc: "service_photo_guide_desc",
  item_video_guide_btn_title: "item_video_guide_btn_title",
  service_video_guide_btn_title: "service_video_guide_btn_title",
  market_format_bold: "market_format_bold",
  market_format_bullet: "market_format_bullet",
  market_format_highlight: "market_format_highlight",
  market_format_warranty_item: "market_format_warranty_item",
  market_format_warranty_service: "market_format_warranty_service",
  market_format_template_item: "market_format_template_item",
  market_format_template_service: "market_format_template_service",
  market_seo_tip_item: "market_seo_tip_item",
  market_seo_tip_service: "market_seo_tip_service",
  crop_photo_title: "crop_photo_title",
  crop_product_photo: "crop_product_photo",
  crop_service_photo: "crop_service_photo",
  crop_drag_hint: "crop_drag_hint",
  crop_rotate_left: "crop_rotate_left",
  crop_rotate_right: "crop_rotate_right",
  crop_reset: "crop_reset",
  crop_ratio_square: "crop_ratio_square",
  crop_ratio_standard: "crop_ratio_standard",
  crop_ratio_free: "crop_ratio_free",
  crop_save_done: "crop_save_done",
  crop_compressing: "crop_compressing",
  party_or_details: "party_or_details",
  report_copied_clipboard: "report_copied_clipboard",
  party: "party",
  sale: "sale",
  purchase: "purchase",
  expense: "expense",
  ai_support_btn: "ai_support_btn",
  ai_support_title: "ai_support_title",
  ai_support_online_status: "ai_support_online_status",
  ai_support_welcome_msg: "ai_support_welcome_msg",
  ai_support_input_hint: "ai_support_input_hint",
  ai_support_typing: "ai_support_typing",
  ai_support_copied: "ai_support_copied",
  ai_support_net_error: "ai_support_net_error",
  ai_support_server_error: "ai_support_server_error",
  ai_support_sugg_plan: "ai_support_sugg_plan",
  ai_support_sugg_dairy: "ai_support_sugg_dairy",
  ai_support_sugg_party: "ai_support_sugg_party",
  ai_support_sugg_backup: "ai_support_sugg_backup",
  ai_support_sugg_bill: "ai_support_sugg_bill",
  ai_support_clear_chat: "ai_support_clear_chat",
  ai_support_clear_title: "ai_support_clear_title",
  ai_support_clear_confirm: "ai_support_clear_confirm",
  help_center_title: "help_center_title",
  help_center_sub: "help_center_sub",
  help_support_title: "help_support_title",
  help_center_heading: "help_center_heading",
  help_center_subheading: "help_center_subheading",
  help_ai_title: "help_ai_title",
  help_ai_live_badge: "help_ai_live_badge",
  help_ai_online_status: "help_ai_online_status",
  help_ai_desc: "help_ai_desc",
  help_ai_chat_btn: "help_ai_chat_btn",
  help_whatsapp_title: "help_whatsapp_title",
  help_whatsapp_sub: "help_whatsapp_sub",
  help_call_title: "help_call_title",
  help_call_number: "help_call_number",
  help_email_title: "help_email_title",
  help_email_id: "help_email_id",
  help_faq_title: "help_faq_title",
  help_faq_1_q: "help_faq_1_q",
  help_faq_1_a: "help_faq_1_a",
  help_faq_2_q: "help_faq_2_q",
  help_faq_2_a: "help_faq_2_a",
  help_faq_3_q: "help_faq_3_q",
  help_faq_3_a: "help_faq_3_a",
  help_faq_4_q: "help_faq_4_q",
  help_faq_4_a: "help_faq_4_a",
  help_footer_call_hours: "help_footer_call_hours",
  help_footer_ai_hours: "help_footer_ai_hours",
  help_footer_branding: "help_footer_branding",
  help_feature_launch_error: "help_feature_launch_error",
};

export default LangKeys;